import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import Truncate from "react-truncate";
import Tooltip from "components/Tooltip";

import cx from 'classnames';
import _ from 'lodash';

import { fetchInteractivePagesReports, fetchInteractivePagesChartReports } from 'actions/interactiveReports';
import { fetchPagesReportsForLandingPage, fetchPagesChartReportsForLandingPage } from 'actions/landingPageReports';

import { TrendsPieChart } from './charts'
import {DropdownFilter} from './dropDown'

import { convertDatesToTimezone } from 'services/report.service';
import { padNumber } from 'services/util';
import { EmptyMessage, LoadingMessage, PageAnalyticsHeader, TableInfo } from '.';
import { TableFooter } from './tableFooter';

import styles from '../report.module.scss';

export function PageAnalytics(props) {
  const dispatch = useDispatch();

  let { storyboardId } = useParams();
  const pages = useSelector(state => _.get(state, 'storyboards.storyboard.reports.pages.items'));
  const chartData = useSelector(state => _.get(state, 'storyboards.storyboard.reports.pages.chartItems'));
  const pagination = useSelector(state => _.get(state, 'storyboards.storyboard.reports.pages.pagination'));
  const loading = useSelector(state => _.get(state, 'storyboards.storyboard.reports.pages.loading'));
  const [currentChart, setCurrentChart] = useState("table_view");
  const [viewOption, setViewOption] = useState({ label: 'Views', value: 'views', name: 'name' })

  useEffect(() => {
    if (props.date) {
      handlePageChange(0);
    }
  }, [props.date]);

  const handlePageChange = (page) => {
    handleFetchPageViewsReport(page);
  }

  const handleFetchPageViewsReport = (page) => {
    var request = {
      storyboard: storyboardId,
      ...convertDatesToTimezone(props.date),
    }

    if (props.storyboardType == "INTERACTIVE_CONTENT") {
      dispatch(fetchInteractivePagesReports(request, page, 5));
      dispatch(fetchInteractivePagesChartReports(request, 0, 6));
    } else {
      dispatch(fetchPagesReportsForLandingPage(request, page, 5));
      dispatch(fetchPagesChartReportsForLandingPage(request, 0, 6));
    }
  }

  const handleChartChange = (value) => {
    setCurrentChart(value)
  }

  const handleArrange = (data) => {
    setViewOption(state =>{
      return {
        ...state,
        label: data.label,
        value: data.value
      }
    });
  }

  return (
    <div className={styles.pageAnalyticsWrapper}>
      <div className={styles.pageAnalyticsContainer}>
        <TableInfo
          name="Page Analytics"
          pagination={pagination} />

        {currentChart == "table_view" && <PageAnalyticsHeader />}

        {currentChart == "pie_chart_view" && <DropdownFilter disableOption={[]}  arrangeOption={viewOption} handleArrange={handleArrange} />}

        {currentChart == "table_view" &&
          !loading && pages && pages.map((data, index) => {
            return <PageReportView data={data} loading={loading} index={index} />
          })
        }

        {(_.size(chartData) > 0 && currentChart == "pie_chart_view") &&
          <div className={styles.graphSmallView}>
            <TrendsPieChart data={chartData} viewOption={viewOption} height={320} width="100%" />
          </div>
        }

        {loading && (pages && pages.length > 0) &&
          <LoadingMessage />
        }

        {(pages && pages.length == 0) && !loading &&
          <EmptyMessage />
        }
      </div>

      <TableFooter
        currentChart={currentChart}
        disableView={['graph_view']}
        handleChartChange={handleChartChange}
        handlePageChange={handlePageChange}
        pagination={pagination}
        leftAlign={true}
        paginationName={"Pages"}
      />
    </div>
  )

  function PageReportView({ loading, data }) {

    const [tooltip, setTooltip] = useState(false);

    if (!data || data.length <= 1) {
      return false;
    }

    const _renderTimeSpent = (seconds) => {
      let minutes = padNumber(Math.floor(seconds / 60), 2);
      seconds = padNumber(Math.floor(seconds % 60), 2);
      var hours = padNumber(Math.floor(minutes / 60), 2);
      minutes = padNumber(minutes % 60, 2);

      hours = hours > 0 ? `${hours}:` : ''
      return `${hours}${minutes}:${seconds}`;
    }

    const handleTooltip = (truncated) => {
      setTooltip(truncated);
    }

    return (
      <div className={styles.pageAnalyticsRow}>
        <div className={cx(styles.wrapper, styles.pageNameColumn)}>
          <div className={styles.headline}>
            <Tooltip placement="top" content={data.name} disabled={!tooltip}>
              <Truncate onTruncate={handleTooltip} lines={1}>{data.name}</Truncate>
            </Tooltip>
          </div>
        </div>

        <div className={cx(styles.wrapper, styles.viewsColumn)}>
          <div className={styles.headline}>{data.views}</div>
        </div>

        <div className={cx(styles.wrapper, styles.visitorsColumn)}>
          <div className={styles.headline}>{data.visitors}</div>
        </div>

        <div className={cx(styles.wrapper, styles.avgTimeSpentColumn)}>
          <div className={styles.headline}>{_renderTimeSpent(data.timeSpent)}</div>
        </div>

        <div className={cx(styles.wrapper, styles.timespentColumn)}>
          <div className={styles.headline}>{data.timeSpent == 0 ? "00:00" : _renderTimeSpent(data.timeSpent / data.views)}</div>
        </div>

        <div className={cx(styles.wrapper, styles.bounceRateColumn)}>
         <div className={styles.headline}>{`${Math.round(data.bounceRate)}%`}</div>
        </div>
      </div>
    )
  }
}
